import BackgroundImg from '../../media/input-background.png';

export const getWebsitePromptInputsStyles = () => ({
  container: {
    width: '100%',
    padding: '36px 36px 34px 36px',
    border: '2px solid',
    borderImage: 'linear-gradient(90deg, #464FEB 35%, #47CFFA 70%, #B47CF8 92%) 1',
    background: `url("${BackgroundImg}")`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    '& .fui-Label': {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 600,
      marginBottom: '8px',
      padding: 0,
    },
    '& .fui-Input': {
      width: '100%',
      height: '53px',
      fontSize: '20px',
      lineHeight: '28px',
    },
    '& .fui-Field__validationMessage': {
      fontSize: '14px',
    },
    '& div[role="alert"]': {
      '& .error': {
        display: 'none',
      },
    },
    '& .summary-text': {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 600,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '& .revise-button': {
      minWidth: 'auto',
      alignSelf: 'center',
      marginTop: '16px',
    },
    '& .refresh-button': {
      minWidth: 'auto',
      alignSelf: 'center',
      marginTop: '16px',
    },
  },
  'container-l': {
    flexDirection: 'column',
  },
  'container-m': {
    flexDirection: 'column',
  },
  'container-s': {
    flexDirection: 'column',
  },
  summaryContainer: {
    padding: 28,
    justifyContent: 'center',
    alignSelf: 'center',
    width: 672,
  },
  'summaryContainer-s': {
    width: '100%',
    '& .summary-text': {
      whiteSpace: 'normal',
    },
  },
  websiteField: {
    flexGrow: 1,
    flexBasis: 0,
    marginBottom: '0px',
  },
  divider: {
    border: '1px solid rgba(224, 224, 224, 1)',
    opacity: 0.8,
    margin: '0px 8px',
  },
  promptField: {
    flexGrow: 1,
    flexBasis: 0,
    '& .input-trigger': {
      width: '100%',
    },
  },
  popup: {
    position: 'relative',
  },
  promptMenu: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#ffffff',
    zIndex: 1,
    '& .suggestion-header': {
      marginLeft: '4px',
    },
  },
  refreshButtonContainer: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'center',
  },
  reviseButtonContainer: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'center',
  },
});
